<div class="assignees-dialog">
  <div class="assignees-dialog__header">
    <span class="assignees-dialog__title" i18n="@@EVENT_ASSIGNEES_LABEL">Assignee(s)</span>
    <button type="button" class="assignees-dialog__close" (click)="close()">
      <sim-icon icon="close2" [sizeInPx]="24" color="var(--text-icon)" />
    </button>
  </div>

  <div class="assignees-dialog__list">
    @for (user of data.assignees; track user.userId) {
      <user-info
        class="assignees-dialog__row"
        [userName]="user.userName || user.userEmail"
        [userEmail]="user.userName ? user.userEmail || '' : ''"
        [userId]="user.userId"
        [userStatus]="user.status"
      />
    }
  </div>
</div>
